/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { useAppDispatch } from 'app/hooks';
import {
    checkEnableParseJSON,
    checkEmptyValue,
    checkNoCreditAwarded,
    checkNoCreditEligible,
    getPointYearFromSchedule,
    checkNoCreditGradeCollege,
    getKeyTypeOfCourse,
    checkWeightedCourse,
    checkTypeOfClass,
    isSemesterOn,
} from 'components/helper/helper';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { authenticateSettings } from 'components/helper/appConfig';
import LoadingContent from 'components/LoadingContent';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import { wCourseSummary } from 'screen/counselor/components/RPersonalInformation';
import courseServices from 'services/courseServices';
import { mapAGSumary_Value } from 'screen/common/helper/fixValuesOnLoad';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

interface Props {}

const W_CourseSummary = (props: Props) => {
  const dispatch = useAppDispatch();
  const history = useHistory();  
  let studentId = getUserId();
  let token = getAccessToken();
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [myAGSummary, setMyAGSummary] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [totalCredits, setTotalCredits] = React.useState(0);

  const conditionGradeTH = (item: any, schedule: any, gradeScale: any) => {
    if (!item) return 0;

    const finalGrade = item.finalGrade;
    const finalCredit = item.finalCredits;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (gradeScale === '1-100') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grade ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === false
        ) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === false &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (gradeScale === '1-100') {
        if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === true &&
          isSemesterOn(item.isSecondSemester) === false
        ) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (
          isSemesterOn(item.isFirstSemester) === false &&
          isSemesterOn(item.isSecondSemester) === true
        ) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  const selectOneSemester = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditAwarded(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const selectOneSemesterEligible = (
    gradeIndex: number,
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      if (
        !checkEmptyValue(grades[gradeIndex]) &&
        !checkEmptyValue(credits[gradeIndex]) &&
        !checkNoCreditEligible(grades[gradeIndex])
      ) {
        point += getPointYearFromSchedule(schedule);
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionCollegeCourses = (item: any, scheduleSystem: string) => {
    if (
      !item ||
      item?.honorStatus !== 'CL' ||
      item?.transferable !== true ||
      item?.completionStatus === 'Select' ||
      checkEmptyValue(item?.grade) ||
      checkNoCreditGradeCollege(item?.grade)
    ) {
      return 0;
    }

    //Change logic make it so that every transferable college course is equal to 1.0 credits
    const pointYear = getPointYearFromSchedule('Yearly');
    return pointYear;
  };

  //For Grade Scale A-F
  const selectTwoSemester = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditAwarded(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditAwarded(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  //For Grade Scale 1-100
  const selectTwoSemesterEligible = (
    scheduleTranscript: any,
    grades: any,
    credits: any,
    schedule: any,
    finalGrade: any,
    finalCredit: any
  ) => {
    if (
      scheduleTranscript === 'One grade per term' ||
      scheduleTranscript === 'One grade per term and one final grade'
    ) {
      let point = 0;
      for (let i = 0; i < 2; i++) {
        //Dùng vòng lặp for cho ngắn gọn
        if (
          !checkEmptyValue(grades[i]) &&
          !checkEmptyValue(credits[i]) &&
          !checkNoCreditEligible(grades[i])
        ) {
          point += getPointYearFromSchedule(schedule);
        }
      }
      return point;
    } else if (scheduleTranscript === 'One final Grade') {
      if (
        checkEmptyValue(finalGrade) ||
        checkEmptyValue(finalCredit) ||
        checkNoCreditEligible(finalGrade)
      ) {
        return 0;
      }
      return getPointYearFromSchedule(schedule);
    }
  };

  const conditionGeneralInfo = (item: any) => {
    if (
      !item ||
      checkEmptyValue(item?.type_of_class) ||
      checkEmptyValue(item?.is_weighted_course)
    ) {
      return 0;
    }

    const schedule = item.schedule; // Lưu giá trị schedule để dùng lại
    const finalGrade = item.final_grade;
    const finalCredit = item.final_credit;
    const gradeScale = item.grade_scale;

    if (schedule === 'Yearly' || schedule === 'Other') {
      if (gradeScale === 'A-F') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditAwarded(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      } else if (gradeScale === '1-100') {
        if (
          checkEmptyValue(finalGrade) ||
          checkEmptyValue(finalCredit) ||
          checkNoCreditEligible(finalGrade)
        ) {
          return 0;
        }
        return getPointYearFromSchedule(schedule);
      }
    } else {
      //semester, quarter, trimester
      const scheduleTranscript = item.schedule_transcript;
      const grades = item.grades ?? []; //Gán mặc định là mảng rỗng để tránh lỗi nếu grades không tồn tại
      const credits = item.credits ?? [];

      if (gradeScale === 'A-F') {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemester(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemester(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemester(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      } else if (gradeScale === '1-100') {
        if (item.isFirstSemester === true && item.isSecondSemester === true) {
          return selectTwoSemesterEligible(
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === true && item.isSecondSemester === false) {
          return selectOneSemesterEligible(
            0,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        } else if (item.isFirstSemester === false && item.isSecondSemester === true) {
          return selectOneSemesterEligible(
            1,
            scheduleTranscript,
            grades,
            credits,
            schedule,
            finalGrade,
            finalCredit
          );
        }
      }
    }
    return 0;
  };

  /*
  const getPointWeightedCourse = (item: any, typeOfClass: any) => {
    const isHonors = checkTypeOfClass(typeOfClass, 'Honors');
    if (isHonors === true) {
      let weightedPoint = getPointYearFromSchedule(item?.schedule);
      return weightedPoint;
    }
    return 0;
  };
  */

  const getData = async () => {
    studentId = getUserId();
    token = getAccessToken();
    try {
      if (token && studentId) {
        setLoading(true);
        const res: any = await caculatorSubjectYears(studentId);
        setMyAGSummary(res);
        setLoading(false);
      }
      else {
        handleLogout();
      }
    } catch (ex) {
    console.log('Error: ', ex);
    }

  };
  const caculatorSubjectYears = async (studentId: any) => {
    let countKeys = {
      WH: 0,
      AP: 0,
      IB: 0,
      TC: 0,
    };
    const resGradeAndCourse: any = await courseServices.getGradeAndCourse(studentId);
    const resGeneral: any = await courseServices.getGeneral(studentId);

    const summary9th = checkEnableParseJSON(resGradeAndCourse?.grade_9_course_array, []);
    const summary10th = checkEnableParseJSON(resGradeAndCourse?.grade_10_course_array, []);
    const summary11th = checkEnableParseJSON(resGradeAndCourse?.grade_11_course_array, []);
    const summary12th = checkEnableParseJSON(resGradeAndCourse?.grade_12_course_array, []);

    const summaryTH = [...summary9th, ...summary10th, ...summary11th, ...summary12th];
    const summaryCollegeCourses = checkEnableParseJSON(
      resGradeAndCourse?.college_course_array,
      []
    );
    const additional_info = checkEnableParseJSON(resGeneral?.additional_info, {});

    (summaryTH ?? []).forEach((item: any) => {
      if (item?.subjectDetails && item?.subjectDetails.length>0) {
        item?.subjectDetails?.forEach((obj: any) => {
            let subject:any = Object.assign({}, obj);
            mapAGSumary_Value(subject);
            const pointYear = conditionGradeTH(subject, item?.schedule, item?.CMGradingScale);
            const typeOfClass = subject?.typeOfClass;
            const isWeightedCourse = subject?.isWeightedCourse;
            if (!checkEmptyValue(pointYear)) {
            //pointYear != 0
            //Type of Class
            const firstLetter = getKeyTypeOfCourse(typeOfClass, wCourseSummary);
            if (firstLetter != null) {
                let currentValue = (countKeys as any)[firstLetter];
                if (checkWeightedCourse(isWeightedCourse)) {
                (countKeys as any)[firstLetter] = currentValue + pointYear;
                }
            }
    
            //Weighted Course
            if (checkWeightedCourse(isWeightedCourse)) {
                const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
                if (keyWeighted != null) {
                const keyWeightedValue = (countKeys as any)[keyWeighted];
                const isHonors = checkTypeOfClass(typeOfClass, 'Honors');
                if (isHonors === true) {
                    (countKeys as any)[keyWeighted] = keyWeightedValue + pointYear;
                }
                }
            }
            } else {
            //pointYear == 0
            if (checkWeightedCourse(isWeightedCourse)) {
                const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
                if (keyWeighted != null) {
                const keyWeightedValue = (countKeys as any)[keyWeighted];
                // (countKeys as any)[keyWeighted] = keyWeightedValue + getPointWeightedCourse(item, typeOfClass);
                }
            }
            }
        });
      }
    });

    (summaryCollegeCourses ?? []).forEach((item: any) => {
        if (item?.collegeCourseArray && item?.collegeCourseArray.length>0) {
            item?.collegeCourseArray?.forEach((subject: any) => {
                const scheduleSystem = item?.scheduleSystem;
                const pointYear = conditionCollegeCourses(subject, scheduleSystem);
                if (!checkEmptyValue(pointYear)) {
                const transferable = subject?.transferable;
                if (transferable === true) {
                    const keyWeighted = getKeyTypeOfCourse(
                    'Transferable College Courses',
                    wCourseSummary
                    );
                    if (keyWeighted != null) {
                    const keyWeightedValue = (countKeys as any)[keyWeighted];
                    (countKeys as any)[keyWeighted] = keyWeightedValue + pointYear;
                    }
                }
                }
            });
        }
    });

    (additional_info?.course_work ?? []).forEach((item: any) => {
      const pointYear = conditionGeneralInfo(item);
      const typeOfClass = item.type_of_class;
      const isWeightedCourse = item.is_weighted_course;
      if (!checkEmptyValue(pointYear)) {
        //pointYear != 0
        //Type of Class
        const firstLetter = getKeyTypeOfCourse(typeOfClass, wCourseSummary);
        if (firstLetter != null) {
          let currentValue = (countKeys as any)[firstLetter];
          if (typeOfClass === 'Regular' && !checkWeightedCourse(isWeightedCourse)) {
            (countKeys as any)[firstLetter] = currentValue + pointYear;
          } else {
            if (checkWeightedCourse(isWeightedCourse)) {
              (countKeys as any)[firstLetter] = currentValue + pointYear;
            }
          }
        }
        //Weighted Course
        if (checkWeightedCourse(isWeightedCourse)) {
          //weighted course = Yes
          const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
          if (keyWeighted != null) {
            const keyWeightedValue = (countKeys as any)[keyWeighted];
            const isHonors = checkTypeOfClass(typeOfClass, 'Honors');
            if (isHonors === true) {
              (countKeys as any)[keyWeighted] = keyWeightedValue + pointYear;
            }
          }
        }
      } else {
        //pointYear == 0
        /*
        if (checkWeightedCourse(isWeightedCourse)) {
          const keyWeighted = getKeyTypeOfCourse('Weighted Honors Courses', wCourseSummary);
          if (keyWeighted != null) {
            const keyWeightedValue = (countKeys as any)[keyWeighted];
            // (countKeys as any)[keyWeighted] = keyWeightedValue + getPointWeightedCourse(item, typeOfClass);
          }
        }
        */
      }
    });

    //Total Points
    const total = Object.values(countKeys).reduce((a, b) => a + b, 0);
    setTotalCredits(total);
    return countKeys;
  };
  React.useEffect(() => {
    getData();
    caculatorSubjectYears(studentId);
  }, []);


  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };  

  const handleContinue = () => {
    history.push(routers.gpaForecaster.path);
  };
  
  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); 

   return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 30, title: '(W) Course Summary' },
          { percentOnProcess: 80, title: 'Continue' },
        ]}
        title="A-G Summary"
        process={1}
        icon={<EventNoteOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form 
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }} 
            className="gm-form-grid"
          >
            <div className="gm-summary-container">
                <div className="gm-summary-section">
                    <div className="gm-summary-section-title">(W) Course Summary</div>
                    <div className="gm-summary-field-grid">
                    {Object.entries(wCourseSummary).map(([key, value]) => (
                        <div key={key} className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                            <span className="subject-text">{value as any}</span>
                        </div>
                        <div className="gm-summary-field-value">{myAGSummary?.[key] || '0'}</div>
                        </div>
                    ))}
                    </div>

                    <div className="gm-summary-field-grid">
                    <div className="gm-summary-field-item">
                        <div className="gm-summary-field-label">
                        <span className="subject-text">Total:</span>
                        </div>
                        <div className="gm-summary-field-value">{totalCredits}</div>
                    </div>
                    </div>
                </div>
            </div>

            <div className="row my-3 pt-3 mt-4 border-top">
              <div className="col-md-12">
                <div className="text-start text-md-end">
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Container>

    </>
  );
};

export default W_CourseSummary;
